"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var Drill = function Drill(_ref) {
  var _ref$color = _ref.color,
      color = _ref$color === void 0 ? '#333' : _ref$color,
      _ref$size = _ref.size,
      size = _ref$size === void 0 ? 'original' : _ref$size;
  var iconSize = size === 'original' ? 'width="35.83" height="24.85"' : 'width="100%"';
  var title = 'Drill Icon';
  return "\n    <svg role=\"img\" aria-label=\"".concat(title, "\" xmlns=\"http://www.w3.org/2000/svg\" ").concat(iconSize, " viewBox=\"0 0 35.83 24.85\">\n      <title>").concat(title, "</title>\n      <path\n        d=\"M0,0V11.15H5.85l-1.13,5.9H.7v7.8H17.07v-7.8H13.62l1.12-5.9h7.64l3.75-1.94V1.94L22.38,0ZM2.1,2.14H21.87L24,3.25V7.9L21.87,9H13L11.07,19.18H15v3.53H2.8V19.18H6.45L8.39,9H2.1Z\"\n        style=\"fill: ").concat(color, "; fill-rule:evenodd;\"\n      />\n      <path\n        d=\"M27.38,9l4.2-.87,4.25-.77V3.84l-4.24-.76-4.21-.87Zm2.1-4.13,1.7.35,2.24.41L31.18,6l-1.7.35Z\"\n        style=\"fill: ").concat(color, "; fill-rule:evenodd;\"\n      />\n    </svg>\n  ");
};

var _default = Drill;
exports["default"] = _default;